import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { Layout } from './components/layout';
import { UIProvider } from './components/ui';
import { HomePage, AboutPage, CaseStudiesPage, ContactPage, AIImplementationPage, AIAuditPartnershipPage, VibeCodePage, PrivacyPolicyPage, TermsOfServicePage } from './pages';

// ============================================
// Page Transition Wrapper
// ============================================

const pageTransitionVariants = {
  initial: {
    opacity: 0,
    y: 20,
  },
  enter: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.4,
      ease: [0.25, 0.46, 0.45, 0.94] as const,
    },
  },
  exit: {
    opacity: 0,
    y: -20,
    transition: {
      duration: 0.3,
      ease: [0.25, 0.46, 0.45, 0.94] as const,
    },
  },
};

const AnimatedRoutes: React.FC = () => {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location.pathname}
        initial="initial"
        animate="enter"
        exit="exit"
        variants={pageTransitionVariants}
      >
        <Routes location={location}>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/case-studies" element={<CaseStudiesPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/services/ai-profit-audit" element={<AIAuditPartnershipPage />} />
          <Route path="/services/ai-implementation" element={<AIImplementationPage />} />
          <Route path="/services/ai-audit-partnership" element={<AIAuditPartnershipPage />} />
          <Route path="/services/vibecode" element={<VibeCodePage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsOfServicePage />} />
        </Routes>
      </motion.div>
    </AnimatePresence>
  );
};

// ============================================
// Main App Component
// ============================================

const App: React.FC = () => {
  return (
    <Router>
      <UIProvider>
        <Layout>
          <AnimatedRoutes />
        </Layout>
      </UIProvider>
    </Router>
  );
};

export default App;
